type HeroData = {
    name: string;
    multiplier: number;
    weight: number;
    speed: number;
    cunning: number;
    luck: number;
    time?: string;
}

export const heroesData: { [key: string]: HeroData } = {
    'Horse-1': {
        name: 'Chill Beatz',
        multiplier: 1.1,
        weight: 1.1,
        speed: 1.1,
        cunning: 1.1,
        luck: 1.1,
    },
    'Horse-2': {
        name: 'Goosicorn',
        multiplier: 2.2,
        weight: 2.2,
        speed: 2.2,
        cunning: 2.2,
        luck: 2.2,
    },
    'Horse-3': {
        name: 'Hot Dog',
        multiplier: 3.3,
        weight: 3.3,
        speed: 3.3,
        cunning: 3.3,
        luck: 3.3,
    },
    'Horse-4': {
        name: 'Julius Cheezer',
        multiplier: 4.4,
        weight: 4.4,
        speed: 4.4,
        cunning: 4.4,
        luck: 4.4,
    },
    'Horse-5': {
        name: 'Raccoon Bros.',
        multiplier: 5.5,
        weight: 5.5,
        speed: 5.5,
        cunning: 5.5,
        luck: 5.5,
    },
    'Horse-6': {
        name: 'Stretch',
        multiplier: 6.6,
        weight: 6.6,
        speed: 6.6,
        cunning: 6.6,
        luck: 6.6,
    },
    'Horse-7': {
        name: 'Tina',
        multiplier: 7.7,
        weight: 7.7,
        speed: 7.7,
        cunning: 7.7,
        luck: 7.7,
    },
    'Horse-8': {
        name: 'Troy',
        multiplier: 8.8,
        weight: 8.8,
        speed: 8.8,
        cunning: 8.8,
        luck: 8.8,
    }
}